//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




import UMUM from         '../../../library/umum'
import FETCHING from  '../../../library/fetching'


export default {
  data() {
    return {

        form : {
            id : '',
            uraian : '',
            keterangan : '',

        },
        list_data : [],

        page_first: 1,
        page_last: 0,
        page_limit : 8,
        cari_value: "",
        type_value : '',
        UMUM : UMUM,
        FETCHING : FETCHING,
        cek_load_data :false,

        mdl_view : false,


    }
  },
  methods: {
    getData : function(){
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_historyData + "view", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value,
              type_value : this.type_value,
              data_batas : this.page_limit
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.cek_load_data = false;
              console.log(res_data);
      });
    },




    // =============================== TAMBAHAN ====================================
      Notify : function(message, positive, icon){
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position : 'top',
          timeout: 500,
        })
      },
      indexing : function(index){
          var idx = ((this.page_first-1)*this.page_limit)+index
          return idx
      },

      cari_data : function(){
          this.page_first = 1;
          this.getData();
      },
    // =============================== TAMBAHAN ====================================

  },

  mounted () {
    this.getData();
  },
}
